import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PIcon } from '@porsche-design-system/components-react';
import { ReactNode } from 'react';

import { Spacer } from './Spacer';

const InlineSidebarWrapper = styled('div', {
  base: {
    boxSizing: 'border-box',
    position: 'absolute',
    pointerEvents: 'all',
    right: 0,
    top: '-1rem',
    bottom: '0',
    width: '380px',
    backgroundColor: 'background.canvas',
    padding: 'md',
    zIndex: 'sidebar',
    overflowY: 'auto',
  },

  variants: {
    isOpen: {
      true: {
        padding: 'lg',
        shadow: 'lg',
      },
      false: {
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: 'border.contrastLower',
        width: '60px',
      },
    },
  },
});

const ToggleIcon = styled(PIcon, {
  base: {
    marginBottom: 'sm',
    borderRadius: 'xl',
    marginRight: 'sm',

    '&:hover': {
      backgroundColor: 'background.frostedSoft',
    },
  },
});

const ToggleButton = styled('div', {
  base: {
    cursor: 'pointer',
    fontSize: '1.2em',
  },

  variants: {
    isVertical: {
      true: {
        textOrientation: 'sideways',
        writingMode: 'vertical-lr',

        '& [data-part="toggle-icon"]': {
          marginRight: 0,
        },
      },
    },
  },
});

export const InlineSidebar = ({
  titleClosed,
  titleOpen,
  isOpen = false,
  onToggle,
  toggleSpacing,
  children,
}: {
  titleClosed: string;
  titleOpen: string;
  isOpen?: boolean;
  toggleSpacing?: string;
  onToggle: (isOpen: boolean) => void;
  children: ReactNode;
}) => (
  <InlineSidebarWrapper isOpen={isOpen} data-cy="sidebar" data-testid="sidebar">
    {isOpen ? (
      <>
        <ToggleButton
          role="button"
          onClick={() => {
            onToggle(!isOpen);
          }}
        >
          <ToggleIcon data-part="toggle-icon" name="arrow-head-right" />
          {titleOpen}
        </ToggleButton>

        <Spacer mt="md" />

        {children}
      </>
    ) : (
      <ToggleButton
        role="button"
        isVertical={true}
        style={{ paddingTop: toggleSpacing }}
        onClick={() => {
          onToggle(!isOpen);
        }}
      >
        <ToggleIcon data-part="toggle-icon" name="arrow-head-left" />
        {titleClosed}
      </ToggleButton>
    )}
  </InlineSidebarWrapper>
);
